<template>
    <div class="famous-pedia">
        <div class="famous-pedia-top-bar">
            <!-- 1. 搜索框 -->
            <div class="famous-pedia-title dsp-flex">
                <div class="famous-pedia-search">
                    <search-input 
                        v-bind:inputId="searchInputId"
                        v-bind:searchData="searchData"
                        v-bind:inputFunc="inputSearch">
                    </search-input>
                </div>
                <div class="famous-pedia-search-button" @click.passive="clickSearch">
                    <span>搜索</span>
                </div>
                <div class="famous-pedia-side" @click.passive="clickFamousInform">
                    <div class="famous-pedia-note"><i class="iconfont icon-bell"></i></div>
                    <span class="famous-pedia-note-num" v-if="totalUnreadNumber != 0">
                        <span>{{totalUnreadNumber > 99 ? '...' : totalUnreadNumber}}</span>
                    </span>
                </div>
            </div>
            <!-- 2. 列表sub menu -->
            <div v-if="!showSearchResult" class="famous-sub-menu dsp-flex">
                <div v-for="item in famousMenu" v-bind:key="item.id" @click.passive="clickMenu(item.id)" class="famous-sub-menu-item"><span v-bind:class="{'cur' : curPediaMenuId == item.id}">{{item.title}}</span></div>
            </div>
            <div v-else class="famous-sub-note">搜索到以下结果：</div>
        </div>
        <!-- 3. 列表内容区域 -->
        <div v-if="!showSearchResult" class="famous-list">
            <!-- 默认列表 -->
            <famous-virtual-list
                v-bind:listData="curPediaListData"
                v-bind:gotData="curPediaListGot"
                v-bind:startCollateFunc="clickStartCollate">
            </famous-virtual-list>
        </div>
        <div v-else class="famous-list">
            <!-- 搜索结果列表 -->
            <famous-virtual-list
                v-bind:listData="searchPediaListData"
                v-bind:gotData="true"
                v-bind:hideLoading="true">
            </famous-virtual-list>
        </div>
        <!-- 4. 新增百科入口 -->
        <div class="famous-add" @click.passive="clickAddFast">
            <div class="famous-add-btn"><i class="iconfont icon-plus-2"></i></div>
        </div>

        <router-view></router-view>
    </div>
</template>
<script>
import SearchInput from '../../components/SearchInput.vue'
import FamousVirtualList from '../../layouts/famouspedia/FamousVirtualList.vue'
import { FAMOUS_DOM } from '../../modules/dom';
export default {
    name: 'FamousPedia',
    components: { SearchInput, FamousVirtualList },
    computed: {
        totalUnreadNumber() {
            return this.$store.state.inform.totalUnreadNumber;
        },
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        curPediaMenuId() {
            return this.$store.state.famouspedia.curPediaMenuId;
        },
        curPediaListGot() {
            return this.$store.state.famouspedia.curPediaListGot;
        },
        curPediaListData() {
            return this.$store.state.famouspedia.curPediaListData;
        },
        searchData() {
            return this.$store.state.search.searchData;
        },
        searchPediaListData() {
            return this.$store.state.famouspedia.searchPediaListData;
        },
    },
    data() {
        return {
            searchInputId: 'pediaSearchInput',
            searchText: '',
            famousMenu: [
                {id: 1, title: '热门名人'},
                {id: 2, title: '最新创建'},
                {id: 3, title: '我的收藏'},
                {id: 4, title: '我的百科'},
                {id: 5, title: '最近浏览'},
            ],
            showSearchResult: false
        }
    },
    mounted() {
        // 加载完成后,静默加载全部列表数据
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }

        this.$store.dispatch('famouspedia/initCurPediaList', {
            curId: this.curPediaMenuId,
            cb: function() {
                FAMOUS_DOM.updateFamouPediaList();
            }
        });
        var me = this;
        setTimeout(() => {
            me.initDom();
            me.initData();
        }, 20);
    },
    methods: {
        initDom() {
            var listDom = document.getElementsByClassName('famous-list')[0],
                topBarDom = document.getElementsByClassName('famous-pedia-top-bar')[0],
                bottomDom = document.getElementsByClassName('bottom-menu-bar')[0];
            if(bottomDom) {
                listDom.style.height = innerHeight - bottomDom.clientHeight + 'px';
            }
            if(topBarDom) {
                listDom.style.paddingTop = topBarDom.clientHeight + 'px';
            }
        },
        initData() {
            this.$store.dispatch('inform/getConfigTips');
        },
        inputSearch(word) {
            this.searchText = word;
            if(word == '') {
                this.showSearchResult = false;
                this.$store.state.famouspedia.searchPediaListData.splice(0);
            }
        },
        clickSearch() {
            var me = this;
            if(this.searchText != '') {
                this.$store.dispatch('famouspedia/getBaikeSearchResult', {
                    text: this.searchText,
                    cb: function(resultList) {
                        me.showSearchResult = resultList.length > 0 ? true : false;
                        if(resultList.length == 0) {
                            me.$toast('搜索不到该百科');
                        }
                    }
                });
            }else {
                this.$toast('请输入要搜索的关键词');
            }
        },
        clickFamousInform() {
            var me = this;
            this.$store.dispatch('inform/getMsgList', {
                cb: function() {
                    me.$router.replace('/famouspedia/inform');
                    FAMOUS_DOM.hideFamousPediaPage();
                }
            });
        },
        clickMenu(menuId) {
            this.$store.dispatch('famouspedia/initCurPediaList', {
                curId: menuId,
                cb: function() {
                    FAMOUS_DOM.updateFamouPediaList();
                }
            });
            this.$bus.emit('scrollFamousToTop');
        },
        clickAddFast() {
            this.$store.dispatch('collate/resetData');
            this.$store.dispatch('collate/initSizhuCollate');
            this.$router.replace('/famouspediacreate');
        },
        clickStartCollate() {
            this.$store.dispatch('collate/initSizhuCollate');
            this.$router.replace('/famouspediacreate')
        }
    }
}
</script>